import { render, staticRenderFns } from "./PageRewards.vue?vue&type=template&id=48ad23bc&scoped=true&"
import script from "./PageRewards.vue?vue&type=script&lang=ts&"
export * from "./PageRewards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad23bc",
  null
  
)

export default component.exports